import { useCallback, useEffect, useState } from "react";
import CardTables from "../atoms/CardTables";
import { GET_CLIENT_CONTACT } from "../../api/apiAdmin";
import { GET_ENTERPRISES_ADMIN } from "../../api/apiEmpresas";
import { useSession } from "../../context/SessionContext";
import EmpresaAdminTable from "../organisms/empresasAdmin/EmpresasAdminTable";
import CardHeader from "../atoms/CardHeader";
import Fuse from "fuse.js";
import EmpresasAdminSearch from "../organisms/empresasAdmin/EmpresasAdminSearch";
import Breadcrumb from "../molecules/Breadcrumb";

const EmpresasAdminTemplate = () => {
    const { user } = useSession();
    const [empresas, setEmpresas] = useState();
    const [filteredEmpresas, setFilteredEmpresas] = useState([]);
    const [clientes, setClientes] = useState();
    const [loading, setLoading] = useState(false);
    const [filters, setFilters] = useState({ empresa: "", rfc: "" });

    const getEnterprises = useCallback ( async () => {
        setLoading(true);

        try {
            const enterprisesData = await GET_ENTERPRISES_ADMIN(user?.roleInfo?.id);
            let filteredEnterprises = enterprisesData;

            const sortedData = filteredEnterprises.sort((a, b) => a.id - b.id);
            setEmpresas(sortedData);
            setFilteredEmpresas(sortedData);
        } catch (error) {
            console.error("Error al obtener empresas:", error);
        }

        try {
            const clientesData = await GET_CLIENT_CONTACT();
            setClientes(clientesData);
        } catch (error) {
            console.error("Error al obtener clientes:", error);
        }

        setLoading(false);
    }, [user]);

	useEffect(() => {
        getEnterprises();
    }, [getEnterprises]);

    useEffect(() => {
        if (!empresas) return;

        const fuse = new Fuse(empresas, {
            keys: [
                { name: "name", weight: 0.5 },
                { name: "rfc", weight: 0.3 },
            ],
            threshold: 0.3,
        });

        const searchTerms = `${filters.empresa} ${filters.rfc}`.trim();

        if (searchTerms) {
            const results = fuse.search(searchTerms).map(result => result.item);
            setFilteredEmpresas(results);
        } else {
            setFilteredEmpresas(empresas);
        }
    }, [filters, empresas]);

    return(
        <div className="space-y-2">
            <CardHeader>
                <Breadcrumb
                    items={[
                        { label: "Inicio", to: "/dashboard" },
                        { label: "Mis empresas", to: null },
                    ]}
                />
            </CardHeader>
            <CardTables>
                <EmpresasAdminSearch filters={filters} setFilters={setFilters} />
                <EmpresaAdminTable data={filteredEmpresas} loading={loading} clients={clientes} refetch={getEnterprises} />
            </CardTables>
        </div>
    );
};

export default EmpresasAdminTemplate;